import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export default function verifyJoinWorkspaceByInvitation(invitationToken: string) {
  return API.post<
    ResponseBaseWithData<{
      signedUser?: {
        id: string;
        email: string;
      };
      company: {
        id: string;
        name: string;
      };
    }>
  >(`/api/v2/users/verify-join-workspace-by-invitation`, {
    data: {
      invitationToken: invitationToken,
    },
  });
}
